module.exports = __webpack_public_path__ + "media/images/home/concept_3-b2d1493d9cee20cf09b267fbfb57b25f.png";